module.exports = __webpack_public_path__ + "img/红参.f65d13fb.jpg";